<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group mb-4">
          <label for="">Export Template Name</label>
          <input type="text" class="form-control" formControlName="name" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.name"
          >
          </control-messages>
        </div>
        <div class="row form-group mb-4 mt-4">
          <div class="col-md-4 my-2" *ngFor="let field of fields; let i = index">
            <label>
              <input
                type="checkbox"
                [value]="field"
                [checked]="checkIfFieldIsChecked(field)"
                (change)="onChangeFieldValue($event)"
              />
              {{ field }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-success">
      <i class="fa fa-save"></i> Submit
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
  </div>
</form>
